import { render, staticRenderFns } from "./PcfKategoriak.vue?vue&type=template&id=5a1b0a0b&"
import script from "./PcfKategoriak.vue?vue&type=script&lang=js&"
export * from "./PcfKategoriak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports